import { useEffect } from "react";
import wkx from "wkx";
import * as L from "leaflet";

import { usePois } from "src/hooks";
import { Poi } from "src/types";
import { getLeafletMarker } from "src/utils/marker.utils";

interface Props {
  map: L.Map;
  params: { caseId: string; poiId?: string };
  callbacks: { onClick: (poiId: string | number) => void };
}
export function PoisOnMap(props: Props) {
  const { map, params, callbacks } = props;
  const { data: pois } = usePois(params.caseId);

  const markersFeatureGroup = L.featureGroup();

  /**
   * Effects
   */
  useEffect(addFeatureGroupToMap, [markersFeatureGroup, map]);
  useEffect(renderPoisOnMap, [params, map, pois, markersFeatureGroup, callbacks]);

  function addFeatureGroupToMap() {
    if (!map) return;
    markersFeatureGroup.addTo(map);

    return function cleanup() {
      markersFeatureGroup.removeFrom(map);
    };
  }

  function renderPoisOnMap() {
    if (!map || !pois) return;

    const markers = pois.reduce((markers: any[], poi: Poi) => {
      // filter out active Poi
      if (params.poiId === poi.id.toString()) return markers;

      // parse geometry to point
      const point = wkx.Geometry.parse(poi.point_frontendSrid) as wkx.Point;

      // define marker
      const marker = getLeafletMarker({ lat: point.y, lng: point.x }, "default", {
        pmIgnore: true,
      });
      marker.on("click", () => {
        if (!map.pm.globalDrawModeEnabled()) {
          callbacks.onClick(poi.id);
        }
      });

      return [...markers, marker];
    }, []);

    markersFeatureGroup.clearLayers();
    markers.forEach((marker) => markersFeatureGroup.addLayer(marker));
  }

  return render();
  function render() {
    return null;
  }
}
